import type { AssessmentListItem } from '@assessments/shared'
import { apiFetch } from '../../services/apiClient.js'

/** Fetches the Manage Assessments list for the current session, in display order. */
export async function fetchAssessments(): Promise<AssessmentListItem[]> {
  const res = await apiFetch('/assessments')
  if (!res.ok) {
    throw new Error(`Failed to load assessments (${res.status})`)
  }
  return (await res.json()) as AssessmentListItem[]
}
